import { render, staticRenderFns } from "./property-info.vue?vue&type=template&id=0168140b&"
import script from "./property-info.vue?vue&type=script&lang=js&"
export * from "./property-info.vue?vue&type=script&lang=js&"
import style0 from "./property-info.vue?vue&type=style&index=0&id=0168140b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports